import {post_data} from './API_Calls.js';
import * as RO from "./ReportObjects.js";

export async function getVesselReportDetails(part_id){
    var param = {
        "part_id": part_id,
        "parent_account_uuid": RO.parent_uuid
    };

    const res = await post_data("/get_VesselDetails", param) || null;
    return RO.formatVesselDetails(res);
}

export async function getVesselsInfo(vessel_uuids, vessel_imos, vessel_mmsi, vessel_part_ids){
    var param = {
        "vessel_uuids": vessel_uuids ? [vessel_uuids] : [],
        "vessel_part_ids": vessel_part_ids ? [vessel_part_ids] : [],
        "vessel_imos": [vessel_imos],
        "vessel_mmsis": [vessel_mmsi],
        "user_account_uuid": RO.current_user
    };

    const res = await post_data("/get_Vessels", param) || null;
    return RO.formatVessel(res[0]);
}